import type { Difficulty, LevelDefinition } from "@/domain";

export const FOCUS_SOCIAL_ACTIVITY_TYPES = [
  "target-search",
  "follow-directions",
  "friendship-stories"
] as const;

export type FocusSocialActivityType =
  (typeof FOCUS_SOCIAL_ACTIVITY_TYPES)[number];

interface FocusSocialLevelMetadata {
  difficulty: Difficulty;
  title: string;
  instruction: string;
  objectives: string[];
}

export function createFocusSocialLevel<TPayload>(
  activityType: FocusSocialActivityType,
  metadata: FocusSocialLevelMetadata,
  payload: TPayload
): LevelDefinition<TPayload> {
  const { difficulty, instruction, objectives, title } = metadata;

  return {
    id: `focus-social-${activityType}-${difficulty}`,
    domain: "focus-social",
    activityType,
    difficulty,
    objectives,
    title,
    instruction,
    promptAudio: `/audio/focus-social/${activityType}-${difficulty}.ogg`,
    assets: [],
    payload
  };
}
